"use client";
import dynamic from "next/dynamic";
import LandingPage from "@/src/components/Home/LandingPage";
import Loading from "@/src/components/Home/Loading";
import { useAuth0 } from "@auth0/auth0-react";
import { useEditorContext } from "@/src/contexts/editorContext";

const Studio = dynamic(() => import("@/src/components/Home/Studio"), {
  loading: () => (
    <div className="min-h-screen w-full" style={{ background: "var(--qk-paper)" }}>
      <Loading />
    </div>
  ),
});

// `defaultAuthed` comes from the server reading the qk_has_session cookie in
// app/page.jsx. We trust it while Auth0 is still resolving (first ~100–500ms
// of a refresh) so the server-rendered HTML matches what we paint after
// hydration — zero flash. Once Auth0 resolves, its answer is authoritative
// and overrides the cookie hint (handles the rare stale-cookie / revoked-
// session case by flipping back to Landing).
export default function AuthStateRouter({ defaultAuthed }) {
  const { isAuthenticated, isLoading } = useAuth0();
  const { isStudioLoading, booksMetadata } = useEditorContext();

  const showAuthed = isLoading ? defaultAuthed : isAuthenticated;

  // Only the first load (no books yet) swaps Studio for the loader: a background
  // refresh that unmounted it made Studio re-run every fetch it makes on mount.
  if (showAuthed && isStudioLoading && booksMetadata.length === 0) {
    return (
      <div className="min-h-screen w-full" style={{ background: "var(--qk-paper)" }}>
        <Loading />
      </div>
    );
  }

  if (showAuthed) {
    return (
      <div className="min-h-screen w-full fade-in-10 bg-[var(--qk-paper)]">
        <Studio />
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full" style={{ background: "var(--qk-paper)" }}>
      <LandingPage />
    </div>
  );
}
